export const SignOutRoute = {
  SIGN_OUT: '/sign-out'
}